module.exports = __webpack_public_path__ + "img/vf.9c686e1a.svg";